module.exports = __webpack_public_path__ + "assets/img/Type BS (15).eb943866.jpg";